import axios from 'axios'
import { environment } from "@/data/environment";
import store from '@/store'
export default async function redirectFormHabeasData(to, from, next) {
    store.dispatch('ui/showLoader')
    try {
        const token = to.params.token
        console.log(token);
        
        if (!token) {
            return next({ name: 'HabeasDataNotFound' })
        }

        const { data } = await axios.get(
            `${environment.HIOPOSWEBSERVICES}/api/habeas-data/validate/${token}`
        )

        store.dispatch('ui/hideLoader')

        if (data.valid === true) {
            return next()
        }
        return next({ name: 'HabeasDataNotFound' })

    } catch (error) {
        console.error('Error validando token HabeasData:', error)
        return next({ name: 'HabeasDataNotFound' })
    }
}
